import { Alert } from '@one-thd/sui-atomic-components';
import React from 'react';
import TrackShipment from '../../order-details/track-shipment/TrackShipment';
import { isLessThan90DaysBetweenDates } from '../../order-details/util/TrackingLogics';
import { dateFormat } from '../../order-details/util/format';
import { weekDayMonthDay } from '../../../constants/dateStrings';
export var CardTrackingDetails = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var item = _a.item, orderStatus = _a.orderStatus, orderNumber = _a.orderNumber, date = _a.date;
    var fulfillmentType = item === null || item === void 0 ? void 0 : item.fulfillmentType;
    var isLessThan90Days = isLessThan90DaysBetweenDates(new Date(), new Date(date));
    var itemDate = dateFormat(((_d = (_c = (_b = item === null || item === void 0 ? void 0 : item.shippingAndHandling) === null || _b === void 0 ? void 0 : _b.applianceDeliveries) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.currentDeliveryDate) ||
        ((_e = item === null || item === void 0 ? void 0 : item.shippingAndHandling) === null || _e === void 0 ? void 0 : _e.estEndDeliveryDate) ||
        ((_f = item === null || item === void 0 ? void 0 : item.bodfsDeliveryAndHandling) === null || _f === void 0 ? void 0 : _f.estEndDeliveryDate), weekDayMonthDay);
    var hasGiftCard = (_g = item === null || item === void 0 ? void 0 : item.lineItems) === null || _g === void 0 ? void 0 : _g.filter(function (lineItem) { return lineItem === null || lineItem === void 0 ? void 0 : lineItem.isGiftCard; }).length;
    return (React.createElement("div", { className: "sui-min-w-[190px] sui-max-w-[385px]" }, !['InStorePurchase', 'InStore', 'MISC', 'unavailable'].includes(fulfillmentType) &&
        ((_h = item === null || item === void 0 ? void 0 : item.lineItems) === null || _h === void 0 ? void 0 : _h.length) !== hasGiftCard && (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
        ![
            'Canceled',
            'Returned',
            'Being Processed',
            'Ready For Pickup',
            'Complete',
            'On Schedule',
            '',
        ].includes(orderStatus !== null && orderStatus !== void 0 ? orderStatus : '') &&
            itemDate === 'Invalid Date, undefined' && (React.createElement(Alert, { status: "error" }, "We were unable to retrieve your shipment details. Refresh the page and try again.")),
        ![
            'Being Processed',
            'Returned',
            'Canceled',
            'Ready For Pickup',
            'Complete',
            '',
        ].includes(orderStatus !== null && orderStatus !== void 0 ? orderStatus : '') &&
            fulfillmentType !== 'BuyOnlinePickupInStore' &&
            isLessThan90Days && (React.createElement(TrackShipment, { buttonVariant: "secondary", orderId: orderNumber, fulfillmentGroup: item, fulfillmentType: fulfillmentType, shipmentIndex: 0 }))))));
};
